/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "../Table/Table";
import { eye_view, view_icon } from "../../assets/img";
import moment from "moment";
import { checkPermission } from "../../screen/redux/api/PermissionManager";

const MMCCancelRequest = ({
  list,
  setPage,
  pagination,
  page,
  setSelectedOwners,
  selectedOwners,
  setIsViewDetails,
}) => {
  const navigate = useNavigate();
  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          const pageSize = 10;
          const isSelected = selectedOwners.includes(
            row.original.unread_notification_id,
          );

          const handleCheckboxChange = (e) => {
            if (e.target.checked) {
              setSelectedOwners((prev) => [
                ...prev,
                row.original.unread_notification_id,
              ]);
            } else {
              setSelectedOwners((prev) =>
                prev.filter((id) => id !== row.original.unread_notification_id),
              );
            }
          };

          return (
            <div
              style={{
                // flexDirection: "row-reverse",
                alignItems: "center",
                display: "flex",
                gap: 5,
              }}
            >
              {row?.original?.has_unread_notification && (
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={handleCheckboxChange}
                  style={{ width: 20, height: 20, marginTop: 9 }}
                />
              )}
              {!row?.original?.has_unread_notification && (
                <img
                  src={eye_view}
                  style={{ width: 20, height: 20, marginTop: 5 }}
                  onChange={() => {
                    setIsViewDetails((prev) => ({
                      ...prev,
                      ispopUp: true,
                      details: row?.original,
                    }));
                  }}
                  onClick={() => {
                    setIsViewDetails((prev) => ({
                      ...prev,
                      ispopUp: true,
                      details: row?.original,
                    }));
                  }}
                />
              )}
              <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>
            </div>
          );
          // return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        },
        // Cell: ({ value, row }) => {
        //   return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        // },
      },
      {
        Header: "Property",
        accessor: "property_name",
        Cell: ({ value, row }) => {
          return (
            <div
              onClick={() => {
                navigate("/property-details", {
                  state: {
                    id: row.original?.property_id,
                    owner: row.original?.owner_id,
                    category_id: row.original?.category_id,
                  },
                });
              }}
              className="text-nowrap"
            >
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.property_code}</p>
            </div>
          );
        },
      },
      {
        Header: "Platform",
        accessor: "payment_device",
        Cell: ({ value, row }) => {
          return (
            <div onClick={() => {}} className="text-nowrap">
              {/* <p className="primary pointer">{value}</p> */}
              <p
                style={{
                  color:
                    row.original.payment_device === "IOS"
                      ? "#ae55f5"
                      : "#3a3a49",
                }}
              >
                {row.original?.payment_device}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Requested By",
        accessor: "requested_by",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Requested Date",
        accessor: "requested_at",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD-MM-YYYY")}</p>;
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              {/* {givenpermissions?.includes("CAN-Edit-ADMINS") && ( */}
              <button
                onClick={() => {
                  navigate("/mmc-cancel-req-view", {
                    state: { type: "view", property: row.original },
                  });
                  // AdminView(row.original.id, "edit");
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className=" edit-btn " />
              </button>
              {/* )} */}
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-VIEW-MMC_CANCELLATION") ? [...d, action] : d;
  }, [page]);

  return (
    <Table
      columns={columns}
      setPageno={setPage}
      pagecount={pagination}
      data={list}
      show={true}
      getRowProps={(row) => ({
        style: {
          backgroundColor: row.original.has_unread_notification
            ? "#eeeeee91"
            : "#fff",
        },
      })}
    />
  );
};
export default MMCCancelRequest;
